"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.detailPopupReducer = void 0;
var typesafe_actions_1 = require("typesafe-actions");
var DetailAction_1 = require("@/pages/detail/actions/DetailAction");
var DetailGalleryAction_1 = require("@/pages/detail/actions/DetailGalleryAction");
var DetailPopupState_init_1 = require("../states/DetailPopupState.init");
exports.detailPopupReducer = function (state, action) {
    if (state === void 0) { state = DetailPopupState_init_1.defaultDetailPopupState; }
    switch (action.type) {
        case typesafe_actions_1.getType(DetailAction_1.default.setPopActive): {
            return __assign(__assign({}, state), { popActiveTab: action.payload });
        }
        case typesafe_actions_1.getType(DetailAction_1.default.setPopRender): {
            console.log('detailPopupReducer DetailAction.setPopRender', action.payload);
            return __assign(__assign({}, state), { popRender: action.payload });
        }
        case typesafe_actions_1.getType(DetailGalleryAction_1.default.setGalleryIndex): {
            if (action.payload.id === 'detail') {
                return __assign(__assign({}, state), { gallery: __assign(__assign({}, state.gallery), { currentIndex: action.payload.index }) });
            }
            if (action.payload.id === 'detailgallery') {
                return __assign(__assign({}, state), { galleryPhotos: __assign(__assign({}, state.galleryPhotos), { currentIndex: action.payload.index }) });
            }
            return state;
        }
        case typesafe_actions_1.getType(DetailGalleryAction_1.default.setPortrait): {
            if (action.payload.id === 'detail') {
                return __assign(__assign({}, state), { gallery: __assign(__assign({}, state.gallery), { items: state.gallery.items.map(function (it, i) {
                            if (i === action.payload.index) {
                                return __assign(__assign({}, it), { isPortrait: action.payload.isPortrait });
                            }
                            return it;
                        }) }) });
            }
            return state;
        }
        // case getType(DetailGalleryAction.onSlideNextClick): {
        //   if (action.payload === 'detailgallery') {
        //     return {
        //       ...state,
        //       id: 'detailgallery'
        //     };
        //   }
        //   return state;
        // }
    }
    return state;
};
